import { API_PATCH, API_POST, DBRequest, useConfig } from "../../api/api";
import ExoStepper, { FinalPage } from "../exo/ExoStepper";
import StepRecipient from "../steps/StepRecipient";
import StepDelivery from "../steps/StepDelivery";
import StepCustomStartUp from "../steps/StepCustomStartUp";
import findDifferences from "../exo/findDifferencesInDataCollection";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import moment from "moment";
import { StepTemplate } from "../steps/StepTemplate";
import { PositionImage } from "../exo/positions/collapse-modules/PositionImage";
import { PositionDescription } from "../exo/positions/collapse-modules/PositionDescription";
import { PositionNumber } from "../exo/positions/collapse-modules/PositionNumber";
import { PositionText } from "../exo/positions/collapse-modules/PositionText";
import { PositionCheckbox } from "../exo/positions/collapse-modules/PositionCheckbox";
import { PositionProgressPaymentCalculation } from "../exo/positions/collapse-modules/PositionProgressPaymentCalcilation";
import { PositionPreCalculation } from "../exo/positions/collapse-modules/PositionPreCalculation";
import { PositionCopy } from "../exo/positions/collapse-modules/PositionCopy";
import StepPositionsOrder from "../steps/StepPositionsOrder";
import useFetch from "../../api/useFetch";
import SelectPositions from "../select/SelectPositions";
import StepOrder from "../steps/StepOrder";
import StepOrderInvoives from "../steps/StepOrderInvoices";
import StepUser from "../steps/StepUser";
import {
  hasInlineAttachments,
  StepInlineAttachments,
} from "../steps/StepInlineAttachments";
import StepTemplateMetaFields from "../steps/StepTemplateMetaFields";

// X-Invoice codes for identifing the type of invoice
export const finalInvoiceCode = [877];
export const progressBillCodes = [875, 876, 877, 326, 877];

const NewProgressBilling = ({
  invoices,
  setInvoices,
  onClose,
  startData,
  onUpdate,
  debug,
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [steps, setSteps] = useState(generateSteps());

  useEffect(() => {
    if (!startData) return;

    let projId;

    if (
      startData.positions &&
      startData.positions.length > 0 &&
      startData.positions[0].project &&
      startData.positions[0].project.length > 0
    ) {
      projId = startData.positions[0].project[0].id;
      let onlyProject = true;

      startData.positions?.forEach((pos) => {
        if (pos.project?.length != 1 && pos.project?.id != projId) {
          onlyProject = false;
        }
      });

      if (onlyProject) {
        startData.project = startData.positions[0].project[0];
      }
    }
  }, [startData]);

  function getPaymentOptions() {
    let options = [];
    options = config ? config?.invoice.paymentOptions.options : [];
    let selection = config ? config?.invoice.paymentOptions.value : [];

    const filteredOptions = options.filter((option) =>
      selection.includes(option.value)
    );
    return filteredOptions;
  }

  useEffect(() => {
    setSteps(generateSteps());
  }, [startData, config]);

  function generateSteps() {
    var requiredFields = [
      {
        label: t("Title"),
        type: "text",
        key: "title",
      },
      {
        label: t("Recipient's Addition"),
        type: "text",
        key: "recipientAddition",
      },
      {
        label: t("Invoice Date"),
        type: "date",
        key: "date",
      },
      {
        label: t("Delivery Date"),
        type: "date",
        key: "deliveryDate",
      },
      {
        label: t("Payment Deadline in Days"),
        type: "number",
        key: "paymentDeadlineInDays",
        decimalPlaces: 0,
      },
      {
        label: t("Payment Method"),
        type: "customSelect",
        key: "paymentMethod",
        noUnselect: true,
        options: getPaymentOptions(),
      },
      {
        label: `${t("Introduction")} (${t("optional")})`,
        type: "description",
        key: "introduction",
        multiline: true,
        textBlockType: "invoice",
      },
      {
        label: `${t("Document note")} (${t("optional")})`,
        type: "description",
        key: "note",
        multiline: true,
        textBlockType: "invoice",
      },
      {
        label: `${t("Internal Note")} (${t("optional")})`,
        type: "description",
        key: "internalNote",
        multiline: true,
        textBlockType: "invoice",
      },
    ];
    var requiredValidationSchema = Yup.object().shape({
      title: Yup.string().required(t("Title is required")),
      date: Yup.string().required(t("Date is required")),
      deliveryDate: Yup.string().required(t("Date is required")),
      paymentDeadlineInDays: Yup.number().required(
        t("Payment Deadline in Days is required")
      ),
      paymentMethod: Yup.number().required(),
    });
    if (config) {
      const useDeliveryDateRange = startData
        ? Boolean(startData.deliveryDateStart)
        : Boolean(parseInt(config.invoice.useDeliveryDateRange));

      requiredFields = [
        {
          label: t("Title"),
          type: "text",
          key: "title",
        },
        {
          label: t("Recipient's Addition"),
          type: "text",
          key: "recipientAddition",
        },
        {
          label: `${t("Project")} (${t("optional")})`,
          type: "project", //Change to "projectSearch" when TypeProjectSearch is done and we want to make the project searchable
          key: "project",
          apiUrl: "projects",
        },
        {
          label: t("Invoice Date"),
          type: "date",
          key: "date",
        },
        {
          label: useDeliveryDateRange
            ? t("Delivery Date Range")
            : t("Delivery Date"),
          type: useDeliveryDateRange ? "dateRange" : "date",
          key: useDeliveryDateRange ? "deliveryDate" : "deliveryDateEnd",
        },
        {
          label: t("Payment Deadline in Days"),
          type: "number",
          key: "paymentDeadlineInDays",
          decimalPlaces: 0,
        },
        {
          label: t("Payment Method"),
          type: "customSelect",
          key: "paymentMethod",
          noUnselect: true,
          options: getPaymentOptions(),
        },
        {
          label: `${t("Introduction")} (${t("optional")})`,
          type: "description",
          key: "introduction",
          multiline: true,
          textBlockType: "invoice",
        },
        {
          label: `${t("Document note")} (${t("optional")})`,
          type: "description",
          key: "note",
          multiline: true,
          textBlockType: "invoice",
        },
        {
          label: `${t("Internal Note")} (${t("optional")})`,
          type: "description",
          key: "internalNote",
          multiline: true,
          textBlockType: "invoice",
        },
      ];
      requiredValidationSchema = useDeliveryDateRange
        ? Yup.object().shape({
            title: Yup.string().required(t("Title is required")),
            date: Yup.string().required(t("Date is required")),
            deliveryDateStart: Yup.string().required(t("Date is required")),
            deliveryDateEnd: Yup.string().required(t("Date is required")),
            paymentDeadlineInDays: Yup.number().required(
              t("Payment Deadline in Days is required")
            ),
            paymentMethod: Yup.number().required(),
          })
        : Yup.object().shape({
            title: Yup.string().required(t("Title is required")),
            date: Yup.string().required(t("Date is required")),
            deliveryDateEnd: Yup.string().required(t("Date is required")),
            paymentDeadlineInDays: Yup.number().required(
              t("Payment Deadline in Days is required")
            ),
            paymentMethod: Yup.number().required(),
          });
    }

    const optionalFields = [
      {
        label: `${t("Discount")} (${t("optional")})`,
        type: "checkbox",
        key: "discount",
      },
      {
        label: `${t("Discount Rate")} (${t("optional")})`,
        type: "number",
        key: "discountRate",
        decimalPlaces: 2,
      },
      {
        label: `${t("Discount Days To Pay")} (${t("optional")})`,
        type: "number",
        key: "discountDaysToPay",
        decimalPlaces: 0,
      },
      {
        label: `${t("Images")} (${t("optional")})`,
        type: "images",
        key: "additionalFiles",
        maxItems: "15",
        maxSizeKB: "3000",
      },
    ];

    var collapsePositionModules = [
      { component: PositionImage, key: "image", label: "Image" },
      {
        component: PositionDescription,
        key: "description",
        label: "Description",
        textBlockType: "invoice",
      },
      {
        component: PositionNumber,
        key: "taxRate",
        label: "Tax Rate",
        unit: "%",
        decimalPlaces: 0,
      },
      {
        component: PositionText,
        key: "unit",
        label: "Unit",
      },
      {
        component: PositionCopy,
        label: "Duplicate position",
      },
    ];

    if (startData && startData.sourceType === "order")
      collapsePositionModules = [
        ...collapsePositionModules,
        {
          component: PositionCheckbox,
          key: "isOrderPosition",
          label: "Settle from order",
        },
        {
          component: PositionProgressPaymentCalculation,
          key: "price",
          label: "Progress Payment Calculation",
        },
      ];

    collapsePositionModules = [
      ...collapsePositionModules,
      {
        component: PositionPreCalculation,
        key: "price",
        label: "Calculation of sales price",
      },
    ];

    return [
      {
        label: t("Order"),
        valid: true,
        content: ({
          updateDataCollection,
          activeStep,
          setActiveStep,
          step,
          dataCollection,
          updateValidation,
        }) => (
          <StepOrder
            onClose={onClose}
            dataCollection={dataCollection}
            updateDataCollection={updateDataCollection}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            step={step}
            updateValidation={updateValidation}
            noTemplate
            removeDrafts={true}
          />
        ),
      },
      {
        label: t("Invoices"),
        valid: false,
        content: ({
          updateDataCollection,
          activeStep,
          setActiveStep,
          step,
          dataCollection,
          updateValidation,
        }) => (
          <StepOrderInvoives
            onClose={onClose}
            dataCollection={dataCollection}
            updateDataCollection={updateDataCollection}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            step={step}
            updateValidation={updateValidation}
          />
        ),
      },
      {
        label: t("Recipient"),
        isHiddenFunction: (data) => Boolean(data?.order?.id),
        content: ({
          dataCollection,
          updateValidation,
          updateDataCollection,
        }) => (
          <StepRecipient
            updateDataCollection={updateDataCollection}
            dataCollection={dataCollection}
            updateValidation={updateValidation}
          />
        ),
      },
      {
        label: t("Template"),
        content: ({
          dataCollection,
          updateValidation,
          updateDataCollection,
          setSteps,
          activeStep,
        }) => (
          <StepTemplate
            updateDataCollection={updateDataCollection}
            dataCollection={dataCollection}
            updateValidation={updateValidation}
            templateType="partial_invoice"
            activeStep={activeStep}
            setSteps={setSteps}
          />
        ),
      },

      {
        label: t("Info"),
        content: ({
          dataCollection,
          updateValidation,
          updateDataCollection,
        }) => (
          <StepCustomStartUp
            fields={requiredFields}
            updateDataCollection={updateDataCollection}
            dataCollection={dataCollection}
            updateValidation={updateValidation}
            validationSchema={requiredValidationSchema}
          />
        ),
      },
      {
        label: t("Additional"),
        content: ({
          dataCollection,
          updateValidation,
          updateDataCollection,
        }) => (
          <StepTemplateMetaFields
            updateDataCollection={updateDataCollection}
            dataCollection={dataCollection}
            updateValidation={updateValidation}
            templateMetaData={dataCollection.templateMetaData}
          />
        ),
        isHiddenFunction: (data) =>
          !Boolean(data.templateMetaData?.metaFields?.length > 0),
      },
      {
        label: `(${t("Optional")})`,
        content: ({
          dataCollection,
          updateValidation,
          updateDataCollection,
        }) => (
          <StepCustomStartUp
            fields={optionalFields}
            updateDataCollection={updateDataCollection}
            dataCollection={dataCollection}
            updateValidation={updateValidation}
          />
        ),
      },
      {
        label: t("Order Positions"),
        content: ({
          dataCollection,
          updateValidation,
          updateDataCollection,
        }) => (
          <StepSelectOrderPositions
            updateDataCollection={updateDataCollection}
            dataCollection={dataCollection}
            updateValidation={updateValidation}
          />
        ),
        isHiddenFunction: (data) =>
          finalInvoiceCode.includes(data?.templateMetaData?.typeCode) ||
          !data.order,
      },
      {
        label: t("Custom Positions"),
        content: ({
          dataCollection,
          updateValidation,
          updateDataCollection,
        }) => (
          <StepPositionsOrder
            updateDataCollection={updateDataCollection}
            dataCollection={dataCollection}
            updateValidation={updateValidation}
            hideTimeBilling={false}
            hideHOAI={false}
            collapseModules={[
              { component: PositionImage, key: "image", label: "Image" },
              {
                component: PositionDescription,
                key: "description",
                label: "Description",
                textBlockType: "invoice",
              },
              {
                component: PositionNumber,
                key: "taxRate",
                label: "Tax Rate",
                unit: "%",
                decimalPlaces: 0,
              },
              {
                component: PositionText,
                key: "unit",
                label: "Unit",
              },
              {
                component: PositionCopy,
                label: "Duplicate position",
              },
              {
                component: PositionCheckbox,
                key: "isOrderPosition",
                label: "Settle from order",
              },
              {
                component: PositionProgressPaymentCalculation,
                key: "price",
                label: "Progress Payment Calculation",
              },
            ]}
            imageType={`INVOICE_ATTACHMENT`}
            imageApiFilter={
              startData && startData.id
                ? `orderImages[has]=${startData.id}`
                : `orderImages[doesnothave]=0`
            }
          />
        ),
        isHiddenFunction: (data) =>
          finalInvoiceCode.includes(data?.templateMetaData?.typeCode),
      },
      {
        label: t("Attachments"),
        content: ({
          dataCollection,
          updateValidation,
          updateDataCollection,
        }) => (
          <StepInlineAttachments
            dataCollection={dataCollection}
            updateDataCollection={updateDataCollection}
            updateValidation={updateValidation}
          />
        ),
        isHiddenFunction: (data) => !hasInlineAttachments(data?.positions),
      },
      {
        label: t("Contact Person"),
        content: ({
          dataCollection,
          updateValidation,
          updateDataCollection,
        }) => (
          <StepUser
            updateDataCollection={updateDataCollection}
            updateValidation={updateValidation}
            dataCollection={dataCollection}
          />
        ),
      },
      {
        label: t("Delivery"),
        content: ({
          dataCollection,
          updateValidation,
          updateDataCollection,
        }) => (
          <StepDelivery
            useInvoiceMail={true}
            updateDataCollection={updateDataCollection}
            dataCollection={dataCollection}
            updateValidation={updateValidation}
            defaultRecipientMailKey="isInvoiceMail"
            allowMailContent={true}
            textBlockType={"invoice"}
          />
        ),
      },
    ];
  }

  const finalStep = {
    operation: ({
      dataCollection,
      handleResponse,
      setIsLoading,
      handleError,
    }) => {
      const diff = findDifferences(startData || {}, dataCollection);

      // invoices sum
      function calcAlreadyInvoicedAmount(key) {
        if (!dataCollection.previousInvoices) return 0;
        var newSum = 0;
        dataCollection.previousInvoices.forEach((element) => {
          newSum += element[key];
        });
        return newSum;
      }

      // create positions if its the final invoice

      const isFinal = finalInvoiceCode.includes(
        dataCollection.templateMetaData?.typeCode
      );
      if (isFinal) {
        // calc the open amount

        const {
          orderPrice,
          orderTaxAmount,
          orderDiscountPercent,
          orderTaxRate,
        } = dataCollection;

        const alreadyPayedNetto = parseFloat(
          calcAlreadyInvoicedAmount("orderEffectiveAmountNetto")
        );
        /*const alreadyPayedBrutto = parseFloat(
          calcAlreadyInvoicedAmount('orderEffectiveBruttoAmount')
        );*/

        const discountPercent = parseFloat(orderDiscountPercent) / 100;
        const discountNetto = discountPercent * orderPrice;

        const priceNetto = orderPrice - alreadyPayedNetto - discountNetto;

        const taxRate = orderTaxRate;

        diff.positions = [
          {
            amount: 1,
            depth: 0,
            taxRate,
            price: priceNetto,
            description: "",
            deliveredAt: null,
            image: null,
            isGroup: false,
            isOptional: false,
            isOrderPosition: true,
            markupRate: "30.00",
            name: t("Final Amount"),
            position: "-",
            positionableId: null,
            positionableType: "custom",
            status: 0,
            unit: "",
          },
        ];
      }

      if (!diff.order) diff.sourceType = "custom";

      DBRequest({
        config,
        path: dataCollection.id ? `invoices/${dataCollection.id}` : `invoices`,
        method: dataCollection.id
          ? API_PATCH({ ...diff, recipientType: dataCollection.recipientType })
          : API_POST(dataCollection),
        onResponse: handleRes,
        onLoading: setIsLoading,
        onError: handleError,
      });

      function handleRes(data) {
        handleResponse(data);
        onUpdate(data);
      }
    }, // your operation with the data
    content: (response) => (
      <FinalPage response={response} data={invoices} setData={setInvoices} />
    ), // component with final operations and the feedback
  };

  const [defaultData, setDefaultData] = useState({});

  useEffect(() => {
    if (!config) return;
    setSteps(generateSteps());
    const today = moment().format();

    const useDeliveryDateRange = Boolean(
      parseInt(config.invoice.useDeliveryDateRange)
    );
    const newDefaultData = {
      date: today,
      deliveryDateStart: useDeliveryDateRange ? today : null,
      deliveryDateEnd: today,
      paymentDeadlineInDays: config.invoice.paymentDeadlineInDays,
      discountRate: config.invoice.discountRate,
      orderTaxRate: config.invoice.discountRate,
      discountDaysToPay: config.invoice.discountPaymentDeadlineInDays,
      useDeliveryDateRange,
      sourceType: "order",
      paymentMethod: getPaymentOptions()[0].value,
    };
    setDefaultData(newDefaultData);
  }, [config]);

  return (
    <ExoStepper
      debug={debug}
      allowDraft
      confirmInvoice
      draftType={"progress-invoice"}
      label={
        startData && startData.id
          ? t("Edit Order Based Invoice")
          : t("New Order Based Invoice")
      }
      startDataCollection={
        startData && startData.id ? startData : { ...defaultData, ...startData }
      }
      message={t("Create Invoice")}
      onClose={onClose}
      data={steps}
      finalStep={finalStep}
      previewDocument="partial_invoice"
    />
  );
};

const StepSelectOrderPositions = ({
  dataCollection,
  updateValidation,
  updateDataCollection,
}) => {
  //load positions
  const { apiData, isLoading } = useFetch(
    `orders/${dataCollection?.order?.id}`
  );

  function handleSelectedPositions(positions) {
    var newPositions = [];

    positions.forEach((element) => {
      newPositions.push({
        ...element,
        isOptional: false,
        orderPositionId: element.id,
        isOrderPosition: true,
        totalAmount: element.amount,
        amount: element.billedAmount
          ? element.amount - element.billedAmount
          : element.amount,
      });
    });

    updateDataCollection({ positions: sortByPosition(newPositions) });
  }
  useEffect(() => {
    updateValidation(true);
  }, []);

  function sortByPosition(arr) {
    return arr.sort((a, b) => {
      const posA = a.position.split(".").map(Number);
      const posB = b.position.split(".").map(Number);

      // Compare each part of the position
      for (let i = 0; i < Math.max(posA.length, posB.length); i++) {
        const partA = posA[i] || 0; // Default to 0 if part is undefined
        const partB = posB[i] || 0; // Default to 0 if part is undefined

        if (partA !== partB) {
          return partA - partB;
        }
      }

      // If all parts are equal
      return 0;
    });
  }

  return (
    <SelectPositions
      positions={!isLoading && apiData.data.positions}
      isLoading={isLoading}
      onSelect={handleSelectedPositions}
      allowAll={true}
      requirePercent={true}
    />
  );
};

export default NewProgressBilling;
